import Spacing from 'ui/types/spacing';
import styled, { css, ExecutionContext } from 'styled-components';

export interface SectionProps {
  $spacing?: Spacing;
}

function getDefaultSectionStyle({ theme, $spacing }: ExecutionContext & SectionProps) {
  if (!$spacing) return null;

  return css<SectionProps>`
    position: relative;
    margin-bottom: ${2 * theme.spacing[$spacing]}rem;

    &:last-child {
      margin-bottom: 0;
    }
  `;
}

export const Section = styled.div<SectionProps>`
  ${getDefaultSectionStyle};
`;
